import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-light py-12 md:py-24 px-4" data-id="element-141">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-4xl mx-auto" data-id="element-142">
        <div className="bg-gradient-to-br from-white to-green-50 rounded-[32px] border border-green-200 shadow-lg p-8 md:p-12 relative overflow-hidden" data-id="element-143">
          <div className="relative z-10" data-id="element-144">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-145">
              <div className="flex-shrink-0" data-id="element-146">
                <div className="w-24 h-24 bg-green-500/10 rounded-full flex items-center justify-center border-4 border-green-500/20" data-id="element-147">
                  <ShieldCheck className="w-12 h-12 text-green-600" data-id="element-148" />
                </div>
              </div>

              <div className="flex-1 text-center md:text-left" data-id="element-149">
                <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline mb-4" data-id="element-150">
                  Mi Garantía{' '}
                  <span className="text-green-600" data-id="element-151">Cero Riesgo</span>
                </h2>
                <p className="text-xl md:text-2xl text-body leading-relaxed" data-id="element-152">
                  Si en 7 días sientes que esto no es para ti, te devuelvo tus
                  $6.36 y te quedas con el material.{' '}
                  <span className="font-bold text-dark" data-id="element-153">
                    No tienes nada que perder.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}